var color={alertWarning:{value:"#f4a423"},alertError:{value:"#e42a2a"},alertSuccess:{value:"#21d362"},neutral800:{value:"#262626"},neutral600:{value:"#555555"},neutral700:{value:"#383a39"},neutral400:{value:"#9d9d9d"},neutral200:{value:"#d9d9d9"},neutral100:{value:"#e9e9e9"},neutral50:{value:"#f5f5f5"},black:{value:"#000000"},white:{value:"#ffffff"},white600:{value:"#e0e0e0"},secondary900:{value:"#005e59"},secondary800:{value:"#008183"},secondary700:{value:"#00969a"},secondary600:{value:"#00abb3"},secondary500:{value:"#00bbc5"},secondary400:{value:"#00c5cb"},secondary300:{value:"#2ecfd2"},secondary200:{value:"#75dedd"},secondary100:{value:"#adebea"},secondary50:{value:"#def7f6"},secondaryDefault:{value:"#00adcc"},primary900:{value:"#b61f1b"},primary800:{value:"#c52a27"},primary700:{value:"#d2312e"},primary600:{value:"#e43b34"},primary500:{value:"#f34435"},primary400:{value:"#ee544f"},primary300:{value:"#e47372"},primary200:{value:"#ef9a99"},primary100:{value:"#ffcdd2"},primary50:{value:"#ffebee"},green100:{value:"#65bb43"},grey:{"default":{value:"#A8AFB3"}}};var tokens = {color:color};

var colors = {
    primary: {
        primary50: tokens.color.primary50.value,
        primary100: tokens.color.primary100.value,
        primary200: tokens.color.primary200.value,
        primary300: tokens.color.primary300.value,
        primary400: tokens.color.primary400.value,
        primary500: tokens.color.primary500.value,
        primary600: tokens.color.primary600.value,
        primary700: tokens.color.primary700.value,
        primary800: tokens.color.primary800.value,
        primary900: tokens.color.primary900.value,
    },
    secondary: {
        secondaryDefault: tokens.color.secondaryDefault,
        secondary50: tokens.color.secondary50.value,
        secondary100: tokens.color.secondary100.value,
        secondary200: tokens.color.secondary200.value,
        secondary300: tokens.color.secondary300.value,
        secondary400: tokens.color.secondary400.value,
        secondary500: tokens.color.secondary500.value,
        secondary600: tokens.color.secondary600.value,
        secondary700: tokens.color.secondary700.value,
        secondary800: tokens.color.secondary800.value,
        secondary900: tokens.color.secondary900.value,
    },
    neutral: {
        black: tokens.color.black.value,
        neutral800: tokens.color.neutral800.value,
        neutral700: tokens.color.neutral700.value,
        neutral600: tokens.color.neutral600.value,
        neutral400: tokens.color.neutral400.value,
        neutral200: tokens.color.neutral200.value,
        neutral100: tokens.color.neutral100.value,
        neutral50: tokens.color.neutral50.value,
        white: tokens.color.white.value,
    },
    alert: {
        success: tokens.color.alertSuccess.value,
        warning: tokens.color.alertWarning.value,
        error: tokens.color.alertError.value,
    },
    white: {
        white600: tokens.color.white600.value,
    },
    grey: {
        default: tokens.color.grey.default.value,
    },
    green: {
        green100: tokens.color.green100.value,
    },
};

export { colors as c };
//# sourceMappingURL=colors-23c56846.js.map
